import { render, staticRenderFns } from "./AbilitySystem.vue?vue&type=template&id=226bb398&scoped=true"
import script from "./AbilitySystem.vue?vue&type=script&lang=js"
export * from "./AbilitySystem.vue?vue&type=script&lang=js"
import style0 from "./AbilitySystem.vue?vue&type=style&index=0&id=226bb398&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226bb398",
  null
  
)

export default component.exports